import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from "prop-types"
import { connect } from "react-redux"
import {
  Col,
  Container,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { map } from "lodash"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

//Import Cards
import CardReport from "./card-birthchart"

import { getBirthChartList } from "store/projects/actions"
import { API_URL } from "helpers/api_helper"
import { replaceAll } from 'components/Common/Util'
import { isEmpty, isEqual } from "lodash"


class ProjectsGrid extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      totalPage: 10, //replace this with total pages of data
      pageSize: 10,
      sortOrder: 'desc',
      search: '',
      userName: '',
      refferedBy: '',
      mobile: '',
      city: '',
      reportCreatedDate: new Date(),
      itemsCountPerPage: null,
      totalItemsCount: null,
      actionResult: {},
      actionResultChanged: false,
      userBirthChartList: [],
      loading: false,

    }
    this.handleDownload = this.handleDownload.bind(this)
  }

  componentDidMount() {
    console.log("componentDidMount->called")
    const { onGetProjects } = this.props
    onGetProjects(0, this.state.pageSize,
      this.state.sortOrder, this.state.reportCreatedDate)
  }

  componentDidUpdate(prevProps, prevState) {
    const { userBirthChartListPage, actionResult } = this.props
    if (!isEmpty(actionResult) && !isEqual(prevProps.actionResult, actionResult)) {
      console.log("componentDidUpdate->actionResult changed")
      this.setState({ actionResult, actionResultChanged: true })
    }

    if (!isEmpty(userBirthChartListPage)) {
      console.log("componentDidUpdate");
      if (!isEqual(prevProps.userBirthChartListPage.userBirthChartList, userBirthChartListPage.userBirthChartList)
        || userBirthChartListPage.size !== this.state.itemsCountPerPage) {
        console.log("componentDidUpdate->birthChartListPageChanged");
        this.setState({
          userBirthChartList: userBirthChartListPage.userBirthChartList,
          totalItemsCount: userBirthChartListPage.totalElements,
          itemsCountPerPage: userBirthChartListPage.size,
          totalPage: userBirthChartListPage.totalPages > 10 ? 10 : userBirthChartListPage.totalPages,
        })
      }
    }
  }

  handlePageClick = page => {
    this.setState({ page })
    console.log("handlePageClick->called")
    const { onGetProjects } = this.props
    onGetProjects(page - 1, this.state.pageSize, this.state.sortOrder,
      this.state.reportCreatedDate)
  }

  handleDownload(birthChartId, birthChartName) {
    this.setState({ loading: true })
    console.log("inside props handle Download :::: project grid common place")
    try {
      const birthReportUrl = "astro-users/birthChart/PDF"
      const obj = JSON.parse(sessionStorage.getItem("authUser"))
      const config = {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'Authorization': 'Bearer ' + obj.token
        },
      }
      fetch(`${API_URL}/${birthReportUrl}?id=${birthChartId}`, config)
        .then(response => {
          if (response.status != 200) {
            return
          }
          const filename = "AIReport_" + replaceAll(birthChartName);
          response.blob().then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
          });
        });

    } catch (error) {
      console.log(error)
    }
    this.setState({ loading: false })
  }

  render() {
    const { page, totalPage, userBirthChartList, actionResult, loading } = this.state
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>View Birth Chart | Kattam - Birth Chart</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="" breadcrumbItem="View AI Reports" />

            <Row>
              <CardReport handleDownload={this.handleDownload} birthChartList={userBirthChartList} key={"birthChart"} />
            </Row>

            <Row>
              <Col lg="12">
                <Pagination className="pagination pagination-rounded justify-content-center mt-2 mb-5">
                  <PaginationItem disabled={page === 1}>
                    <PaginationLink
                      previous
                      href="#"
                      onClick={() => this.handlePageClick(page - 1)}
                    />
                  </PaginationItem>
                  {map(Array(totalPage), (item, i) => (
                    <PaginationItem active={i + 1 === page} key={'_k' + i}>
                      <PaginationLink
                        onClick={() => this.handlePageClick(i + 1)}
                        href="#"
                      >
                        {i + 1}
                      </PaginationLink>
                    </PaginationItem>
                  ))}
                  <PaginationItem disabled={page === totalPage}>
                    <PaginationLink
                      next
                      href="#"
                      onClick={() => this.handlePageClick(page + 1)}
                    />
                  </PaginationItem>
                </Pagination>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

ProjectsGrid.propTypes = {
  userBirthChartListPage: PropTypes.object,
  actionResult: PropTypes.object,
  birthChartList: PropTypes.array,
  onGetProjects: PropTypes.func,
}

const mapStateToProps = ({ projects }) => ({
  //birthChartList: projects.birthChartList,
  userBirthChartListPage: projects.userBirthChartListPage,
  actionResult: projects.actionResult
})

const mapDispatchToProps = dispatch => ({
  onGetProjects: (page, size, sortOrder, reportCreatedDate) => dispatch(getBirthChartList(page, size, sortOrder, reportCreatedDate))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProjectsGrid))
